import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const PHASES = [
  { label: 'Breathe In', secs: 4, scale: 1, hint: 'Inhale for 4 seconds' },
  { label: 'Hold', secs: 7, scale: 1, hint: 'Hold your breath for 7 seconds' },
  { label: 'Breathe Out', secs: 8, scale: 0.45, hint: 'Exhale for 8 seconds' },
];
const ROUNDS = 4;

// Guided 4-7-8 breath, four rounds
export default function BreathingExercise({ onClose }) {
  const [step, setStep] = useState(0);
  const done = step >= PHASES.length * ROUNDS;
  const phase = PHASES[step % PHASES.length];

  useEffect(() => {
    if (done) return undefined;
    const id = setTimeout(() => setStep((s) => s + 1), phase.secs * 1000);
    return () => clearTimeout(id);
  }, [step, done, phase.secs]);

  return (
    <div className="fixed inset-0 z-[9999] bg-[#1f2740]/95 flex flex-col items-center justify-center px-6 text-center" data-testid="f2-breathing">
      <button onClick={onClose} className="absolute top-6 right-6 text-[#f4ead8]/70 hover:text-[#f4ead8]" data-testid="f2-breathing-close" aria-label="Close"><X size={26} /></button>
      <div className="relative w-64 h-64 flex items-center justify-center mb-10">
        <div
          className="absolute inset-0 rounded-full bg-[#e9b872]/25 border border-[#e9b872]/60"
          style={{ transform: `scale(${done ? 0.45 : phase.scale})`, transition: `transform ${phase.secs}s ease-in-out` }}
        />
        <span className="relative font-heading text-3xl text-[#f4ead8]" data-testid="f2-breathing-phase">{done ? 'Well done' : phase.label}</span>
      </div>
      <p className="font-body text-[#f4ead8]/80 mb-2">{done ? 'Notice how your body feels now.' : phase.hint}</p>
      <p className="font-body text-xs uppercase tracking-[0.3em] text-[#e9b872]">
        {done ? `${ROUNDS} rounds complete` : `Round ${Math.floor(step / PHASES.length) + 1} of ${ROUNDS}`}
      </p>
      {done && <button onClick={onClose} className="mt-8 font-body text-sm px-6 py-2.5 rounded-full bg-[#e9b872] text-[#2b3550]" data-testid="f2-breathing-finish">Back to my week</button>}
    </div>
  );
}
